/**
 * The site is laid out no narrower than a small iPhone (375 px, global.css). In a narrower window — a browser's
 * side panel, a split view — the whole page is scaled down to fit instead, so it neither squeezes nor scrolls
 * sideways. The native app has its own minimum window size and is left alone.
 */
export const NARROWEST = 375;

export function fitScale(width: number): number | null {
  return width > 0 && width < NARROWEST ? width / NARROWEST : null;
}

export function installNarrowFit(): void {
  if (typeof window === 'undefined') return;
  const root = document.documentElement;
  const fit = (): void => {
    if (root.dataset.app !== undefined) return;
    const scale = fitScale(window.innerWidth);
    if (scale === null) root.style.removeProperty('zoom');
    else root.style.setProperty('zoom', scale.toFixed(4));
  };
  fit();
  window.addEventListener('resize', fit, { passive: true });
}
